<template>
  <div class="col-options-data-dialog">
    <el-collapse v-model="activeNames">
      <el-collapse-item @mousedown.native="collapseMouseDown($event, '1')" title="基础设置" name="1" class="padding0">
        <div class="content mb16" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '1')">
          <collapsibleItem
            :name="collapse.top.title"
            :type="collapse.top.type"
            :is-active="collapse.top.isActive"
            @collapsibleItemClick="collapsibleItemClickHandle($event, 1)"
          >
            <div slot="heading">{{ collapse.top.title }}</div>
            <div slot="body">
              <div v-if="collapseDataActiveNames.length !== 0 && collapseDataActiveNames.find(it => it == 1) > -1">
                <div class="content-item">
                  <el-checkbox v-model="isShowTop">显示标题栏</el-checkbox>
                  <i class="tips-btn icon-portal-info2" @click="explainDialogClick('top')"></i>
                </div>
                <div v-if="isShowTop" class="content-item">
                  <slider-and-input
                    class=""
                    :value.sync="topHeight"
                    title="高度"
                    :sliderMax="500"
                    :sliderMin="0"
                    suffix="px"
                  />
                </div>
                <template v-if="isShowTop">
                  <div
                    v-for="(titleComponent, index) in titleComponents[0].elementOptions"
                    :key="index"
                    class="content-item"
                    v-show="!(pageType === 'listPage' && titleComponent.type === 'more')"
                  >
                    <el-checkbox
                      :value.sync="titleComponent.isShow"
                      :disabled="titleComponent.disabled"
                      @change="checkboxDisplayHandle($event, 0, titleComponent)"
                      >{{ titleComponent.title }}</el-checkbox
                    >
                    <i class="tips-btn icon-portal-info2" @click="explainDialogClick(titleComponent.type)"></i>
                  </div>
                </template>
              </div>
            </div>
          </collapsibleItem>
          <collapsibleItem
            :name="collapse.left.title"
            :type="collapse.left.type"
            :is-active="collapse.left.isActive"
            @collapsibleItemClick="collapsibleItemClickHandle($event, 2)"
          >
            <div slot="heading">{{ collapse.left.title }}</div>
            <div slot="body">
              <div v-if="collapseDataActiveNames.length !== 0 && collapseDataActiveNames.find(it => it == 2) > -1">
                <div class="content-item">
                  <el-checkbox v-model="isShowLeft">显示左侧栏</el-checkbox>
                  <i class="tips-btn icon-portal-info2" @click="explainDialogClick('left')"></i>
                </div>
                <div v-if="isShowLeft" class="content-item">
                  <slider-and-input
                    class=""
                    :value.sync="leftWidth"
                    title="宽度"
                    :sliderMax="500"
                    :sliderMin="0"
                    suffix="px"
                  />
                </div>
                <template v-if="isShowLeft">
                  <div
                    v-for="(titleComponent, index) in titleComponents[2].elementOptions"
                    :key="index"
                    class="content-item"
                    v-show="!(pageType === 'listPage' && titleComponent.type === 'more')"
                  >
                    <el-checkbox
                      :value.sync="titleComponent.isShow"
                      :disabled="titleComponent.disabled"
                      @change="checkboxDisplayHandle($event, 2, titleComponent)"
                      >{{ titleComponent.title }}</el-checkbox
                    >
                    <i class="tips-btn icon-portal-info2" @click="explainDialogClick(titleComponent.type)"></i>
                  </div>
                  <template v-if="request_prefix.includes('app')">
                    <cx-check-box :value.sync="isDrawerModeL">抽屉模式</cx-check-box>
                    <template v-if="isDrawerModeL">
                      <cx-check-box :value.sync="drawerL">显示抽屉</cx-check-box>
                      <cx-select :value.sync="inBodyL" :selectOptions="drawerSelectOptions" title="抽屉位置" />
                    </template>
                  </template>
                </template>
              </div>
            </div>
          </collapsibleItem>
          <collapsibleItem
            :name="collapse.right.title"
            :type="collapse.right.type"
            :is-active="collapse.right.isActive"
            @collapsibleItemClick="collapsibleItemClickHandle($event, 3)"
          >
            <div slot="heading">{{ collapse.right.title }}</div>
            <div slot="body">
              <div v-if="collapseDataActiveNames.length !== 0 && collapseDataActiveNames.find(it => it == 3) > -1">
                <div class="content-item">
                  <el-checkbox v-model="isShowRight">显示右侧栏</el-checkbox>
                  <i class="tips-btn icon-portal-info2" @click="explainDialogClick('right')"></i>
                </div>
                <div v-if="isShowRight" class="content-item">
                  <slider-and-input
                    class=""
                    :value.sync="rightWidth"
                    title="宽度"
                    :sliderMax="500"
                    :sliderMin="0"
                    suffix="px"
                  />
                </div>
                <template v-if="isShowRight">
                  <div
                    v-for="(titleComponent, index) in titleComponents[3].elementOptions"
                    :key="index"
                    class="content-item"
                    v-show="!(pageType === 'listPage' && titleComponent.type === 'more')"
                  >
                    <el-checkbox
                      :value.sync="titleComponent.isShow"
                      :disabled="titleComponent.disabled"
                      @change="checkboxDisplayHandle($event, 3, titleComponent)"
                      >{{ titleComponent.title }}</el-checkbox
                    >
                    <i class="tips-btn icon-portal-info2" @click="explainDialogClick(titleComponent.type)"></i>
                  </div>
                  <template v-if="request_prefix.includes('app')">
                    <cx-check-box :value.sync="isDrawerModeR">抽屉模式</cx-check-box>
                    <template v-if="isDrawerModeR">
                      <cx-check-box :value.sync="drawerR">显示抽屉</cx-check-box>
                      <cx-select :value.sync="inBodyR" :selectOptions="drawerSelectOptions" title="抽屉位置" />
                    </template>
                  </template>
                </template>
              </div>
            </div>
          </collapsibleItem>
          <collapsibleItem
            :name="collapse.bottom.title"
            :type="collapse.bottom.type"
            :is-active="collapse.bottom.isActive"
            @collapsibleItemClick="collapsibleItemClickHandle($event, 4)"
          >
            <div slot="heading">{{ collapse.bottom.title }}</div>
            <div slot="body">
              <div v-if="collapseDataActiveNames.length !== 0 && collapseDataActiveNames.find(it => it == 4) > -1">
                <div class="content-item">
                  <el-checkbox v-model="isShowBottom">显示底部栏</el-checkbox>
                  <i class="tips-btn icon-portal-info2" @click="explainDialogClick('bottom')"></i>
                </div>
                <div v-if="isShowBottom" class="content-item">
                  <slider-and-input
                    class=""
                    :value.sync="bottomHeight"
                    title="高度"
                    :sliderMax="500"
                    :sliderMin="0"
                    suffix="px"
                  />
                </div>
                <template v-if="isShowBottom">
                  <div
                    v-for="(titleComponent, index) in titleComponents[1].elementOptions"
                    :key="index"
                    class="content-item"
                    v-show="!(pageType === 'listPage' && titleComponent.type === 'more')"
                  >
                    <el-checkbox
                      :value.sync="titleComponent.isShow"
                      :disabled="titleComponent.disabled"
                      @change="checkboxDisplayHandle($event, 1, titleComponent)"
                      >{{ titleComponent.title }}</el-checkbox
                    >
                    <i class="tips-btn icon-portal-info2" @click="explainDialogClick(titleComponent.type)"></i>
                  </div>
                </template>
              </div>
            </div>
          </collapsibleItem>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-if="request_prefix === 'bigScreen'"
        @mousedown.native="collapseMouseDown($event, '3')"
        title="高级设置"
        name="3"
        class="padding0"
      >
        <div class="content" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '3')">
          <collapsibleItem
            :name="collapse.advanced.title"
            :type="collapse.advanced.type"
            :is-active="collapse.advanced.isActive"
            @collapsibleItemClick="collapsibleItemClickHandle($event, 7)"
          >
            <div slot="heading">{{ collapse.advanced.title }}</div>
            <div slot="body">
              <div v-if="collapseDataActiveNames.length !== 0 && collapseDataActiveNames.find(it => it == 5) > -1">
                <div class="content-item mt12">
                  <el-checkbox v-model="openHideEmptyCell">隐藏空白数据</el-checkbox>
                </div>
                <div v-if="!turnOnScroll">
                  <div style="line-height: 18px; padding: 8px 0">
                    <span style="margin-right: 0">{{ collapse.order.title }}</span>
                    <i class="tips-btn icon-portal-info2" @click="explainDialogClick('order')"></i>
                  </div>
                  <div>
                    <div class="childPageSettingBtn" @click="editCellOrder">
                      <span class="icon icon-portal-setting1"></span>
                      <span>配置顺序</span>
                    </div>
                  </div>
                </div>
                <div class="content-item mt12">
                  <cx-check-box :value.sync="diffCategory">
                    <span>组件分类样式独立</span>
                  </cx-check-box>
                </div>
              </div>
            </div>
          </collapsibleItem>
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips">
        <span>{{ explainTitle }}：</span>{{ explainTips }}
      </p>
      <div class="box">
        <img :src="explainImgSrc" v-if="explainImgSrc" alt="" class="img" />
        <video :src="explainVideoSrc" controls v-if="explainVideoSrc"></video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { findTabs } from "utils"
import { layout_title_drawer_button_children } from "materials/button/menus"
import { getAppointCacheData } from "utils/updateData/publicDataUtils/getRestClassify.js"
import { CATEGORY_MODE } from "@/consts/index.js"
export default {
  props: {
    options: { type: Object },
    container_id: { type: [Number, String] },
    rect_id: { type: [Number, String] }
  },
  data() {
    return {
      this1: this,
      activeNames: ["1", "2", "3"],
      collapseActiveNames: ["1", "2", "3"],
      drawerSelectOptions: [
        {
          label: "页面",
          value: true
        },
        {
          label: "组件",
          value: false
        }
      ],
      collapse: {
        top: {
          title: "标题栏",
          type: "top",
          isActive: true
        },
        bottom: {
          title: "底部栏",
          type: "bottom",
          isActive: true
        },
        left: {
          title: "左侧栏",
          type: "left",
          isActive: true
        },
        right: {
          title: "右侧栏",
          type: "right",
          isActive: true
        },
        list: {
          title: "列表页",
          type: "list",
          isActive: false
        },
        detail: {
          title: "详情页",
          type: "detail",
          isActive: false
        },
        advanced: {
          title: "数据设置",
          type: "advanced",
          isActive: true
        },
        order: {
          title: "自定义数据顺序",
          type: "order",
          isActive: true
        }
      }, // 用来存放当前数据组和图例设置里面的展开收起状态
      collapseDataActiveNames: ["1", "2", "3", "4", "5"],
      // 用户配置项回显 // 先给一个默认值
      titleComponents: [
        {
          directionIndex: 0,
          elementOptions: [
            {
              type: "classification",
              title: "显示分类",
              elementInLayoutId: 0,
              isShow: true,
              disabled: false
            },
            {
              type: "more",
              title: "显示更多按钮",
              elementInLayoutId: 1,
              isShow: true,
              disabled: false
            }
          ]
        },
        {
          directionIndex: 1,
          elementOptions: [
            {
              type: "classification",
              title: "显示分类",
              elementInLayoutId: 0,
              isShow: false,
              disabled: true
            },
            {
              type: "more",
              title: "显示更多按钮",
              elementInLayoutId: 1,
              isShow: false,
              disabled: true
            },
            {
              type: "pagination",
              title: "显示分页",
              elementInLayoutId: 2,
              isShow: true,
              disabled: false
            }
          ]
        },
        {
          directionIndex: 2,
          elementOptions: [
            {
              type: "classification",
              title: "显示分类",
              elementInLayoutId: 0,
              isShow: false,
              disabled: true
            },
            {
              type: "more",
              title: "显示更多按钮",
              elementInLayoutId: 1,
              isShow: false,
              disabled: true
            }
          ]
        },
        {
          directionIndex: 3,
          elementOptions: [
            {
              type: "classification",
              title: "显示分类",
              elementInLayoutId: 0,
              isShow: false,
              disabled: true
            },
            {
              type: "more",
              title: "显示更多按钮",
              elementInLayoutId: 1,
              isShow: false,
              disabled: true
            }
          ]
        }
      ],
      publicId: null,
      explainDialog: false,
      explainTitle: "",
      explainTips: "",
      explainImgSrc: "",
      explainVideoSrc: "",
      bottomPaginationShow: false
    }
  },
  computed: {
    pageType() {
      return this.$store.state[this.request_prefix].type
    },
    ids() {
      return this.$store.state.states.activeID
    },
    isShowTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.titleOptions[0], "isShow", "isShow", true)
      },
      set(newVal) {
        if (!newVal) {
          this.titleComponents[0].elementOptions.forEach(item => {
            this.checkboxDisplayHandle(false, 0, item)
          })
        }
        const completeParam = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          directionIndex: 0,
          changingTitleElement: true
        }
        this.$changeOptionsEV(newVal, "isShow", false, false, completeParam)
      }
    },
    topHeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.titleOptions[0], "height", "height", 60)
      },
      set(newVal) {
        const completeParam = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          directionIndex: 0,
          changingTitleElement: true
        }
        this.$changeOptionsEV(newVal, "height", false, false, completeParam)
      }
    },
    isShowBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.titleOptions[1], "isShow", "isShow", true)
      },
      set(newVal) {
        if (!newVal) {
          this.titleComponents[1].elementOptions.forEach(item => {
            this.checkboxDisplayHandle(false, 1, item)
          })
        } else {
          // 找出底部栏的分页组件
          const pagination = this.titleComponents[1].elementOptions.find(item => {
            return item.type === "pagination"
          })
          this.checkboxDisplayHandle(true, 1, pagination)
        }
        const completeParam = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          directionIndex: 1,
          changingTitleElement: true
        }
        this.$changeOptionsEV(newVal, "isShow", false, false, completeParam)
      }
    },
    bottomHeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.titleOptions[1], "height", "height", 60)
      },
      set(newVal) {
        const completeParam = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          directionIndex: 1,
          changingTitleElement: true
        }
        this.$changeOptionsEV(newVal, "height", false, false, completeParam)
      }
    },
    isShowLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.titleOptions[2], "isShow", "isShow", true)
      },
      set(newVal) {
        if (!newVal) {
          this.titleComponents[2].elementOptions.forEach(item => {
            this.checkboxDisplayHandle(false, 2, item)
          })
        }
        const completeParam = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          directionIndex: 2,
          changingTitleElement: true
        }
        this.$changeOptionsEV(newVal, "isShow", false, false, completeParam)
      }
    },
    leftWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.titleOptions[2], "width", "width", 60)
      },
      set(newVal) {
        const completeParam = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          directionIndex: 2,
          changingTitleElement: true
        }
        this.$changeOptionsEV(newVal, "width", false, false, completeParam)
      }
    },
    isShowRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.titleOptions[3], "isShow", "isShow", true)
      },
      set(newVal) {
        if (!newVal) {
          this.titleComponents[3].elementOptions.forEach(item => {
            this.checkboxDisplayHandle(false, 3, item)
          })
        }
        const completeParam = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          directionIndex: 3,
          changingTitleElement: true
        }
        this.$changeOptionsEV(newVal, "isShow", false, false, completeParam)
      }
    },
    rightWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.titleOptions[3], "width", "width", 60)
      },
      set(newVal) {
        const completeParam = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          directionIndex: 3,
          changingTitleElement: true
        }
        this.$changeOptionsEV(newVal, "width", false, false, completeParam)
      }
    },
    isDrawerModeL: {
      get() {
        const val = this.checkAndSetPrimaryVal(this.options, "isDrawerModeL", "isDrawerModeL")
        const hasBtn = this.options.titleOptions[0].elementOptions.find(item => item.options.drawerPosition === "L")
        if (val === true) {
          //将左侧的多级下拉改为点击激活
          this.checkMenuTriggerType("L")
          //检测自由布局头部框内是否有按钮开关，如果没有就要初始化一个
          if (hasBtn === undefined) {
            this.initDrawerBtn("L")
          }
          //显示左侧栏
          this.isShowLeft = true
        } else {
          //检测自由布局头部框内是否有按钮开关，如果有就要删除
          if (hasBtn !== undefined) {
            this.delDrawerBtn(hasBtn.elementInLayoutId)
          }
        }
        return val
      },
      set(val) {
        this.$changeOptionsEV(val, "isDrawerModeL")
      }
    },
    drawerL: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "drawerL", "drawerL", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "drawerL")
      }
    },
    inBodyL: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "inBodyL", "inBodyL", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "inBodyL")
      }
    },
    inBodyR: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "inBodyR", "inBodyR", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "inBodyR")
      }
    },
    isDrawerModeR: {
      get() {
        const val = this.checkAndSetPrimaryVal(this.options, "isDrawerModeR", "isDrawerModeR")
        const hasBtn = this.options.titleOptions
          .find(it => it.type === "top")
          .elementOptions.find(item => item.options.drawerPosition === "R")
        if (val === true) {
          //将右侧的多级下拉改为点击激活
          this.checkMenuTriggerType("R")
          //检测自由布局头部框内是否有按钮开关，如果没有就要初始化一个
          if (hasBtn === undefined) {
            this.initDrawerBtn("R")
          }
          //显示右侧侧栏
          this.isShowRight = true
        } else {
          //检测自由布局头部框内是否有按钮开关，如果有就要删除
          if (hasBtn !== undefined) {
            this.delDrawerBtn(hasBtn.elementInLayoutId)
          }
        }
        return val
      },
      set(val) {
        console.log("this.options,val :>> ", this.options, val)
        this.$changeOptionsEV(val, "isDrawerModeR")
      }
    },
    drawerR: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "drawerR", "drawerR", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "drawerR")
      }
    },
    turnOnScroll: {
      get() {
        return this.options.turnOnScroll || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "turnOnScroll", false)
      }
    },
    // 是否开启隐藏空数据的单元格 默认开启
    openHideEmptyCell: {
      get() {
        return this.options.hasOwnProperty("openHideEmptyCell") ? this.options.openHideEmptyCell : true
      },
      set(val) {
        this.$changeOptionsEV(val, "openHideEmptyCell", false)
      }
    },
    diffCategory: {
      get() {
        return this.options.categoryMode !== CATEGORY_MODE.SAME
      },
      set(newVal) {
        this.$changeOptionsEV(newVal ? CATEGORY_MODE.DIFF : CATEGORY_MODE.SAME, "categoryMode", false, null)
        // 切换为相同样式，只保留一份
        if(!newVal) {
          this.options.rows.splice(1)
        } else {
          // 切换为不同样式，需要根据tabsList的数量生成多份
          const rowLens = this.options.rows.length
          const tabLens = this.options.tabsList.length
          for(let i = 0; i < tabLens - rowLens; i++) {
            const tempRow = simpleDeepClone(this.options.rows[0])
            this.options.rows.push(tempRow)
          }
        }
      }
    },
  },
  created() {
    this.initTitleComponents()
    this.getPublicId()
  },
  methods: {
    initTitleComponents() {
      // 获取分类、更多、分页组件的真实显示位置elementOptions
      const titleOptions = this.options.titleOptions
      let classifyIndex, moreIndex
      for (let i = 0; i < titleOptions.length; i++) {
        //头部
        if (i === 0 && titleOptions[i].elementOptions.length === 1) {
          this.titleComponents[0].elementOptions.forEach(item => {
            item.isShow = false
          })
        }
        for (let j = 0; j < titleOptions[i].elementOptions.length; j++) {
          let itemObj = titleOptions[i].elementOptions[j]
          let titleElementOp = this.titleComponents[i].elementOptions
          const classificationObj = titleElementOp.find(item => item.type === "classification")
          const moreObj = titleElementOp.find(item => item.type === "more")
          const paginationObj = titleElementOp.find(item => item.type === "pagination")
          if (itemObj.type === "classification") {
            classifyIndex = i
            classificationObj.isShow = itemObj.isShow
            classificationObj.elementInLayoutId = itemObj.elementInLayoutId
            classificationObj.disabled = !itemObj.isShow
          } else if (itemObj.type === "more") {
            moreIndex = i
            moreObj.isShow = itemObj.isShow
            moreObj.elementInLayoutId = itemObj.elementInLayoutId
            moreObj.disabled = !itemObj.isShow
          } else if (itemObj.type === "pagination") {
            paginationObj.isShow = itemObj.isShow
            // paginationObj.elementInLayoutId = titleOptions[i].elementOptions[j].elementInLayoutId
            paginationObj.disabled = false // 分页组件只会存在下面
          }
          if (itemObj.isShow) {
            if (i !== 0 && (itemObj?.type === "classification" || itemObj?.type === "more")) {
              let obj1 = this.titleComponents[0].elementOptions.find(obj => obj.type === itemObj.type)
              obj1.isShow = false
              obj1.disabled = true
            }
          } else {
            if (i === 0 && (itemObj?.type === "classification" || itemObj?.type === "more")) {
              let obj1 = this.titleComponents[0].elementOptions.find(obj => obj.type === itemObj.type)
              obj1.isShow = false
              obj1.disabled = false
            }
          }
        }
      }
      let itemClassify = this.titleComponents[classifyIndex]?.elementOptions.find(
        item => item.type === "classification" && !item.isShow
      )
      if (itemClassify) {
        this.titleComponents.forEach(item1 => {
          let itemClassify2 = item1?.elementOptions.find(item2 => item2?.type === "classification")
          itemClassify2.disabled = false
        })
      }
      let itemMore = this.titleComponents[moreIndex]?.elementOptions.find(item => item.type === "more" && !item.isShow)
      if (itemMore) {
        this.titleComponents.forEach(item1 => {
          let itemMore2 = item1?.elementOptions.find(item2 => item2?.type === "more")
          itemMore2.disabled = false
        })
      }
    },
    checkMenuTriggerType(type) {
      const titleOption = this.options.titleOptions.find(item => item.type === (type === "L" ? "left" : "right"))
      const directionIndex = type === "L" ? 2 : 3
      for (let i = 0; i < titleOption.elementOptions.length; i++) {
        if (titleOption.elementOptions[i].innerElement.includes("Menu")) {
          const completeParam = {
            container_id: this.ids.container_id,
            rect_id: this.ids.rect_id,
            directionIndex,
            elementInLayoutId: titleOption.elementOptions[i].elementInLayoutId,
            option_name: "menuTrigger",
            option_val: "click"
          }
          this.$store.dispatch(this.request_prefix + "/changeTitleOptions", completeParam)
        }
      }
    },
    initDrawerBtn(type) {
      const btn = JSON.parse(JSON.stringify(layout_title_drawer_button_children[0].attribute.options))
      console.log("btn :>> ", btn)
      btn.drawerPosition = type
      btn.isCustomComponent = true
      btn.name = type === "L" ? "左侧抽屉按钮" : "右侧抽屉按钮"
      btn.top = 0
      if (type === "L") {
        btn.left = 0
      } else {
        const rectElWidth = document.getElementsByClassName(
          this.$event.getIdsByStrId({
            container_id: this.ids.container_id,
            rect_id: this.ids.rect_id
          })
        )[0].offsetWidth
        btn.left = rectElWidth - btn.width
      }
      if (btn.hasOwnProperty("pluginName") === false) btn.pluginName = ["layoutTitleOptionDrawerPlugin"]
      else btn.pluginName.push("layoutTitleOptionDrawerPlugin")
      this.$store.dispatch(this.request_prefix + "/addComponentInLayoutAround", {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        direction: 0,
        elementOptions: btn
      })
    },
    delDrawerBtn(elementInLayoutId) {
      this.$store.dispatch(this.request_prefix + "/delLayoutAroundElement", {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        directionIndex: 0,
        elementInLayoutId
      })
    },
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    // 抽屉展开收起方法
    collapsibleItemClickHandle($event, index) {
      this.collapse[$event.type].isActive = $event.isActiveCopy
      const _index = this.collapseDataActiveNames.findIndex(it => it === index)
      _index === -1 ? this.collapseDataActiveNames.push(index + "") : ""
    },
    checkboxDisplayHandle(flag, direction, elementParam) {
      let titleOptions = JSON.parse(JSON.stringify(this.options.titleOptions))
      this.titleComponents[direction].elementOptions.find(
        it => it.elementInLayoutId === elementParam.elementInLayoutId
      ).isShow = flag
      // 当改变显示位置时，需要将其他的显示位置设置为不显示,当取消显示位置时，需要将其他的显示位置设置为显示
      this.titleComponents.forEach((element, i) => {
        if (i !== direction) {
          element.elementOptions.forEach((item, j) => {
            if (item.type === elementParam.type) {
              if (flag) {
                item.disabled = true
              } else {
                item.disabled = false
              }
            }
          })
        }
      })
      const { directionIndex, elementInLayoutId } = findTabs(
        this.options,
        {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id
        },
        elementParam.type
      )
      if (direction === directionIndex && elementParam.elementInLayoutId === elementInLayoutId) {
        // 说明是原来的位置，不需要改变
        titleOptions[direction].elementOptions.find(it => it.elementInLayoutId === elementInLayoutId).isShow = flag
      } else if (this.options.titleOptions[directionIndex]) {
        // 说明是新的位置，需要改变
        const elementComponent = JSON.parse(
          JSON.stringify(
            this.options.titleOptions[directionIndex].elementOptions.find(
              it => it.elementInLayoutId === elementInLayoutId
            )
          )
        )
        if (elementComponent.isShow === true && direction !== directionIndex) return
        // 同时返回数组下标
        const elementComponentIndex = this.options.titleOptions[directionIndex].elementOptions.findIndex(
          it => it.elementInLayoutId === elementInLayoutId
        )
        titleOptions[directionIndex].elementOptions.splice(elementComponentIndex, 1) // 删除原来的位置
        titleOptions[direction].elementOptions.push(elementComponent) // 添加到新的位置并且需要更新elementInLayoutId
        if (titleOptions[direction].elementOptions.length > 1) {
          titleOptions[direction].elementOptions.sort((a, b) => a.elementInLayoutId - b.elementInLayoutId) // 排序
          const newElementInLayoutId =
            titleOptions[direction].elementOptions[titleOptions[direction].elementOptions.length - 1]
              .elementInLayoutId + 1 // 最后一个元素的位置加1
          elementComponent.elementInLayoutId = newElementInLayoutId
          titleOptions[direction].elementOptions.find(it => it.elementInLayoutId === newElementInLayoutId).isShow = flag
        } else {
          titleOptions[direction].elementOptions.find(it => it.elementInLayoutId === elementInLayoutId).isShow = flag
        }
      }
      // 更多按钮不能正确显示在左右两侧
      if (flag === true && (direction === 2 || direction === 3) && elementParam.type === "more") {
        let options = titleOptions[direction].elementOptions.find(it => it.type === elementParam.type).options
        if (options.leftType != "%")
          titleOptions[direction].elementOptions.find(it => it.type === elementParam.type).options.left = 0
      }
      if (flag === true && (direction === 0 || direction === 1) && elementParam.type === "more") {
        let options = titleOptions[direction].elementOptions.find(it => it.type === elementParam.type).options
        if (options.leftType != "%")
          titleOptions[direction].elementOptions.find(it => it.type === elementParam.type).options.left = 660
      }
      console.log("titleOptions", titleOptions)
      this.$changeOptionsEV(titleOptions, "titleOptions", false, false, false, true)
      //  解决大屏同步失败的问题：自由布局组件没有被赋值属性tabsList
      if(flag === true && elementParam.type === "classification"){
        let tabsData = []
        let obj = titleOptions[direction].elementOptions.find(it => it.type === "classification").options
        if(obj){
          tabsData = obj.tabsList
          this.$changeOptionsEV(tabsData, "tabsList", false)
        }
      }
      if (direction === 1 && elementParam.type === "pagination") {
        if (flag === true) {
          this.bottomPaginationShow = true
        } else {
          this.bottomPaginationShow = false
        }
      }
    },
    async getPublicId() {
      const { websiteId, pageId, wfwfid } = this.$store.state.states.getDataPageIds
      const rectAttr = this.getRectAttribute(this.ids)
      const appId = rectAttr?.options?.appId
      console.log("rectAttr :>>", rectAttr, appId)
      if (!appId) return
      const { restUrl } = await getAppointCacheData.call(this, pageId, wfwfid, websiteId, appId)
      console.log("restUrl:>>", restUrl)
      this.publicId = restUrl.data.data.engineInstance.publicId
    },
    explainDialogClick(type) {
      this.explainDialog = true
      switch (type) {
        case "top":
          this.explainTitle = "显示标题栏"
          this.explainTips = "在图文/文本列表的顶部，用来放置标题、分类、装饰元素等的区域"
          this.explainVideoSrc = ""
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/show-title.png")
          break
        case "left":
          this.explainTitle = "显示左侧栏"
          this.explainTips = "在图文/文本列表的左侧，用来放置标题、分类、装饰元素等的区域"
          this.explainVideoSrc = ""
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/show-left.png")
          break
        case "right":
          this.explainTitle = "显示右侧栏"
          this.explainTips = "在图文/文本列表的右侧，用来放置标题、分类、装饰元素等的区域"
          this.explainVideoSrc = ""
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/show-right.png")
          break
        case "bottom":
          this.explainTitle = "显示底部栏"
          this.explainTips = "在图文/文本列表的底部，用来放置分页、分类、装饰元素等的区域"
          this.explainVideoSrc = ""
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/show-bottom.png")
          break
        case "more":
          this.explainTitle = "显示更多"
          this.explainTips = "在预览页点击点击【更多/查看更多】按钮后，就会进入展示全部数据的列表页"
          this.explainVideoSrc = ""
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/show-more.png")
          break
        case "classification":
          this.explainTitle = "显示分类"
          this.explainTips = "选择是否需要展示列表中数据的分类"
          this.explainVideoSrc = ""
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/show-tab.png")
          break
        case "pagination":
          this.explainTitle = "显示分页"
          this.explainTips = "选择是否需要展示列表中数据的总条数、总页数等"
          this.explainVideoSrc = ""
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/show-paging.png")
          break
        case "order":
          this.explainTitle = "数据生成顺序"
          this.explainTips =
            "手动指定数据生成顺序，例如排行榜需要指定中间单元格优先生成数据。注意，如果修改单元格行列数量，会将生成顺序恢复为“从左到右，从上到下”顺序。"
          this.explainImgSrc = require("../../../assets/images/tipsVideoImg/show-order.png")
          this.explainVideoSrc = ""
          break
        default:
      }
    },
    editCellOrder() {
      this.$store.commit("states/changeGeneralAttr", {
        valName: "isOrderPattern",
        val: true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.toolbar .padding0 ::v-deep .el-collapse-item__content {
  padding: 0 16px 0 16px !important;
}
.childPageSettingBtn {
  background: var(--leftMenuBgColor);
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  font-size: 13px;
  line-height: 18px;
  text-align: center;
  color: var(--themeColor);
  padding: 5px 0;
}
.childPageSettingBtn:hover {
  cursor: pointer;
}
.layoutConfig-card {
  border: 1px solid #e9e9e9;
  border-radius: 4px;
  position: relative;
  .img-box {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background-color: rgba(245, 246, 248, 1);
    background-position: top;
    background-size: contain;
    background-clip: padding-box;
    background-repeat: no-repeat;
    background-size: 100%;
    height: 100%;
  }
  .footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    padding: 12px;
    gap: 9.13px;
    position: absolute;
    width: 100%;
    height: 42px;
    left: 0px;
    bottom: 0px;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(14.6087px);
    .title {
      font-size: 13px;
      line-height: 18px;
      color: #000000;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      width: 104px;
    }
    .desc {
      cursor: pointer;
      font-weight: 400;
      font-size: 13px;
      line-height: 18px;
      color: #2b67ff;
      display: flex;
      align-items: center;
    }
  }
  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 4px 4px 4px 12px;
    background: #fbfcfd;
    .title {
      font-weight: 500;
      font-size: 13px;
      line-height: 18px;
      color: rgba(0, 0, 0, 0.8);
    }
    .btn {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #2b67ff;
      cursor: pointer;
    }
  }
  .config-content {
    padding: 12px 12px 0 12px;
    font-weight: 400;
    font-size: 13px;
    line-height: 18px;
    color: rgba(0, 0, 0, 0.8);
    .el-radio {
      margin-top: 0;
      margin-bottom: 0;
      margin-right: 0;
      white-space: pre-wrap;
    }
    .cx-check-box {
      display: inline-block;
    }
    .tips-btn {
      line-height: 20px;
    }
  }
}
.cover {
  height: 132px;
}
.tips-btn {
  display: inline-block;
  vertical-align: top;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  font-size: 14px;
  color: var(--thirdTextColor);
  margin-left: 2px;
  cursor: pointer;
  border-radius: 4px;
}
.tips-btn:hover {
  color: var(--themeColor);
}
</style>
